module.exports = __webpack_public_path__ + "static/media/goodAnswer.d8a14bea.png";